
<template>
<!-- Component not needed any more? -->
<div>
    <div v-for="document in documents" @click="documentClicked(document)" class="pa-3 item-pulse border-transparent transition clickable hoverable document-item" style="border-radius:10px" :key="document.title">
        <template v-if="!document.received">
            <v-btn v-if="!document.received" class="big-tick" icon style="margin-top:-15px;margin-right:-15px;">
                <v-icon @click.stop="markAsReceived(document)">check_circle</v-icon>
            </v-btn>
            <b>{{document.name}}</b>
            <span class="elevation-1 " style="background-color:darkorange;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">
                {{document.title}}
            </span><br/>

            {{document.description}}
            <template v-if="document.download">
                <br/>
                <a @click.stop="false" :href="document.download" target="_blank">
                <button style="margin-top:5px; margin-bottom:0px; color: #444 ;background-color:white;border-radius:3px;border:solid 1px #c0c0c0; padding:5px 18px 5px 18px;user-select: none;">Download</button>
                </a>
            </template>
        </template>  
        <template v-else>
            <b>{{document.name}}</b>
            <span class="elevation-1 " style="background-color:green;padding:2px 5px 2px 5px; border-radius:3px;color:white;font-weight:bold;margin-left:4px;font-size:0.85em;white-space:nowrap">
                Received
            </span>
        </template>  
    </div>
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import NiceData from '../../data/NiceData'
import StringHelpers from '../../helpers/StringHelpers'

export default {
    data() {
        return {
            officeDocumentObject: null,
        }
    },

    components: {
        
    },
    
    props: {
        documents: Array,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        initialise() {
            //todo: change this to take lender as prop.
            let ref = DataHelpers.getTenantRef().child('documentChecklist').child('General')
            NiceData.fetchItemSingle(ref).then(obj => {
                delete obj.meta
                this.officeDocumentObject = obj
            })
        },

        camelToNormal(str) {
            return StringHelpers.camelToNormal(str)
        },

        markAsReceived(document) {
            let newDocument = {...document}
            newDocument.received = true
            this.$emit('change', newDocument )
        },

        documentClicked(document) {
            this.$emit('click', document)
        }

    },

    created() {
        this.initialise()
    }
}
</script>

<style scoped>
.big-tick {
    float:right;color:transparent
}
.document-item:hover > .big-tick {
    color: #ccc;
}
.big-tick:hover {
    color: #1c75d2!important;
}
</style>




// WEBPACK FOOTER //
// ChecklistItems.vue?336fd6da